class SessionStoragePolyfill {
  constructor() {
    this.length = 0;

    let data = window.name;

    if (data) {
      try {
        this.data = JSON.parse(data);
      } catch (e) {
        this.data = data
      }
    } else {
      this.data = {};
    }
  }

  clear() {
    this.data = {};
    this.length = 0;
    this._clearData();
  }

  getItem(key) {
    return this.data[key] === undefined ? null : this.data[key];
  }

  key(i) {
    // not perfect, but works
    let ctr = 0;
    for (let k in this.data) {
      if (ctr == i) return k;
      else ctr++;
    }
    return null;
  }

  removeItem(key) {
    if (this.data[key] === undefined) this.length--;
    delete this.data[key];
    this._setData();
  }

  setItem(key, value) {
    if (this.data[key] === undefined) this.length++;
    this.data[key] = value + ''; // forces the value to a string
    this._setData();
  }

  _setData() {
    window.name = JSON.stringify(this.data);
  }

  _clearData() {
    window.name = '';
  }
}

export let sessionStoragePolyfill = new SessionStoragePolyfill();



// WEBPACK FOOTER //
// ./source/client/data-providers/sessionstorage-polyfill.js